namespace GeniuzPOS.ReportMasterData {
    export interface Report_1105Row {
        MbType?: string;
        MbId?: string;
        MbNameT?: string;
        MbAccumPoint?: number;
        MbNearlyExpirePoint?: number;
        MbExpirePointDate?: string;
        MbCardStatus?: number;
        MbExpireDate?: string;
        MbProvince?: string;
        MbAmphur?: string;
        MbTumbol?: string;
    }

    export namespace Report_1105Row {
        export const idProperty = 'MbId';
        export const nameProperty = 'MbId';
        export const localTextPrefix = 'ReportMasterData.Report_1105';
        export const deletePermission = '';
        export const insertPermission = '';
        export const readPermission = '';
        export const updatePermission = '';

        export declare const enum Fields {
            MbType = "MbType",
            MbId = "MbId",
            MbNameT = "MbNameT",
            MbAccumPoint = "MbAccumPoint",
            MbNearlyExpirePoint = "MbNearlyExpirePoint",
            MbExpirePointDate = "MbExpirePointDate",
            MbCardStatus = "MbCardStatus",
            MbExpireDate = "MbExpireDate",
            MbProvince = "MbProvince",
            MbAmphur = "MbAmphur",
            MbTumbol = "MbTumbol"
        }
    }
}
